import { tokens } from '@/theme'

interface Props {
  /** Number of placeholder rows to render. */
  rows: number
  /** Pixel height of each row. Defaults to 44 — list-row scale. */
  rowHeight?: number
  /** Max width of the column. Mirrors the surrounding content's width. */
  maxWidth?: number | string
}

/**
 * Loading skeleton — gentle pulse, warm-neutral fill matching the brand
 * palette. Used by every list view for the first-fetch state.
 */
export function SkeletonList({ rows, rowHeight = 44, maxWidth = '100%' }: Props) {
  return (
    <ul style={{ listStyle: 'none', display: 'grid', gap: 8, maxWidth }}>
      {Array.from({ length: rows }).map((_, i) => (
        <li
          key={i}
          style={{
            height: rowHeight,
            background: tokens.paper3,
            borderRadius: tokens.radiusMd,
            animation: `skeletonPulse 1.4s ease-in-out ${i * 80}ms infinite alternate`,
          }}
        />
      ))}
      <style>{`@keyframes skeletonPulse { from { opacity: 0.5; } to { opacity: 1; } }`}</style>
    </ul>
  )
}
